// extracted by mini-css-extract-plugin
export default {"root_container":"aWilrvughLxqFYUS9vHx","dashboard":"_gLBvyxRhJAT1TpnMCSd"};